import React from 'react';
import css from './Table.module.scss';
import PropTypes from 'prop-types';
import {useTableContext} from './TableContext';
import ColumnResizeHandle from './ColumnResizeHandle';
import {buildStickyStyle} from './stickyStyle';

const TableHeader = ({
  width,
  children,
  style,
  align,
  className = '',
  rowSpan,
  colSpan,
  resizable = false,
  columnId,
  sticky = false,
  stickyOffset,
  stickyTop,
  stickyRight,
}) => {
  const {cellAlign, columnWidths} = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';
  const isLeaf = !colSpan || Number(colSpan) <= 1;
  const isResizable = resizable && isLeaf && columnId !== undefined && columnId !== null;
  const storedWidth = columnId !== undefined && columnId !== null ? columnWidths[columnId] : undefined;
  const appliedWidth = storedWidth ?? width;
  const stickyStyle = buildStickyStyle({sticky, stickyOffset, stickyTop, stickyRight});

  return (
    <th
      data-column-id={columnId ?? undefined}
      className={`${css.th} ${isResizable ? css.thResizable : ''} ${sticky ? css.sticky : ''} ${className}`.trim()}
      style={{width: appliedWidth ?? undefined, textAlign: finalAlign, ...stickyStyle, ...style}}
      rowSpan={rowSpan ?? undefined}
      colSpan={colSpan ?? undefined}
    >
      {children}
      {isResizable &&
        <ColumnResizeHandle columnId={columnId} />
      }
    </th>
  );
};

TableHeader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  rowSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resizable: PropTypes.bool,
  columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sticky: PropTypes.bool,
  stickyOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default TableHeader;
